import { SolvCSSObject } from './systemTypes';

const TypeClasses = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'subtitle',
  'subtitle2',
  'button',
  'body',
  'body2',
  'caption',
] as const;

export type Variant<Keys extends string> = Record<Keys, SolvCSSObject>;

export type TypeVariants = typeof TypeClasses[number];

export const typography: Variant<TypeVariants> = {
  h1: {
    fontSize: ['2xl', '3xl'],
    lineHeight: ['2xl', '3xl'],
    fontWeight: 'bold',
    fontFamily: 'sans',
  },
  h2: {
    fontSize: 'xl',
    lineHeight: 'xl',
    fontWeight: 'bold',
    fontFamily: 'sans',
  },
  h3: {
    fontSize: 'lg',
    lineHeight: 'lg',
    fontWeight: 'bold',
    fontFamily: 'sans',
  },
  h4: {
    fontSize: 'base',
    lineHeight: 'base',
    fontWeight: 'bold',
    fontFamily: 'sans',
  },
  h5: {
    fontSize: 'sm',
    lineHeight: 'sm',
    fontWeight: 'bold',
    fontFamily: 'sans',
  },
  subtitle: {
    fontSize: 'base',
    lineHeight: 'base',
    fontWeight: 'medium',
    fontFamily: 'sans',
  },
  subtitle2: {
    fontSize: 'sm',
    lineHeight: 'sm',
    fontWeight: 'medium',
    fontFamily: 'sans',
  },
  button: {
    fontSize: 'base',
    lineHeight: 'base',
    fontWeight: 'medium',
    fontFamily: 'sans',
  },
  body: {
    fontSize: 'base',
    lineHeight: 'base',
    fontWeight: 'regular',
    fontFamily: 'sans',
  },
  body2: {
    fontSize: 'sm',
    lineHeight: 'sm',
    fontWeight: 'regular',
    fontFamily: 'sans',
  },
  caption: {
    fontSize: 'xs',
    lineHeight: 'xs',
    fontWeight: 'regular',
    fontFamily: 'sans',
  },
};
